// extracted by mini-css-extract-plugin
export default {"item":"Stores_item__IIoLp","error":"Stores_error__f305q"};